export const twitterverse = '/welcome'
export const connect = '/connect'
export const singleUser = '/user'
export const loading = '/loading'
export const certificate = '/certified'
